import { COLORS } from '@btime/constants'
import { propEq } from 'ramda'
import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'

import { usePlaceTypes } from '../../../utils/helpers/placeTypes'
import { useQrcode } from '../_load/QrcodeLoader'
import { useQueryParams } from '../../../utils/contexts/UrlProvider'
import { useSaveQrcode } from './_requests/saveQrcode'
import AssetSelect from '../../../containers/assets/select/AssetSelect'
import Button from '../../../components/actions/Button'
import FlexGrid from '../../../components/structure/FlexGrid'
import MFooter from '../../../components/structure/M.Footer'
import PlaceSelect from '../../../containers/places/select/PlaceSelect'
import Select from '../../../packages/kiti/components/form/Select'
import Separator from '../../../components/helpers/Separator'
import Text, { Label } from '../../../packages/kiti/components/presentation/Text'

const ActivateQrcodeForm = ({ id }) => {
  const { t } = useTranslation('qrcodes')
  const qrcode = useQrcode()
  const { type: queryParamsType } = useQueryParams()

  const [placeTypes] = usePlaceTypes()
  const initialTypeKey = qrcode?.type || queryParamsType
  const [type, setType] = useState({
    id: initialTypeKey,
    name: initialTypeKey === 'assets' ? 'Ativo' : placeTypes.find(propEq('key', initialTypeKey))?.name
  })
  const [record, setRecord] = useState()

  const [location, setLocation] = useState()

  const [activate, { loading, error }] = useSaveQrcode(id, record, type?.id)

  const RecordSelect = type?.id === 'assets' ? AssetSelect : PlaceSelect

  const placeIds = location && location?.id

  return (
    <>
      <>
        <Label>Tipo</Label>
        <Select
          disableEmptyOption
          value={type}
          onChange={v => {
            setRecord(undefined)
            setLocation(undefined)
            setType(v)
          }}
          options={[
            { id: 'assets', name: 'Ativo' },
            ...placeTypes.map(placeType => ({ id: placeType.key, name: placeType.name }))
          ]}
        />
      </>

      {type?.id === 'assets' && (
        <>
          <Separator weight={4} />

          <Label>Local</Label>
          <PlaceSelect
            key={location?.id}
            disabled={!type?.id}
            onChange={v => {
              setRecord(undefined)
              setLocation(v)
            }}
            value={location}
          />
        </>
      )}

      <Separator weight={4} />

      <>
        <Label>{type?.name || '---'}</Label>
        <RecordSelect
          key={type?.id}
          filter={{ placeIds }}
          disabled={!type?.id}
          type={type?.id}
          onChange={setRecord}
          value={record}
        />
      </>

      <Separator weight={8} />

      <MFooter>
        <FlexGrid justify="space-between" gutter={0.5}>
          <Text color={COLORS.red}>{error?.message}</Text>
          <Button onClick={activate} loading={loading} disabled={!record?.id || !type?.id}>
            Ativar
          </Button>
        </FlexGrid>
      </MFooter>
    </>
  )
}

export default ActivateQrcodeForm
